module.exports = {"pathContext":{"name":"PriceTier","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"tier","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"unitFee","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-price-tier.json
// module id = 1283
// module chunks = 201803807800378